import React, { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import {
  Box,
  Container,
  Grid,
  makeStyles
} from '@material-ui/core';
import { Pagination } from '@material-ui/lab';
import Page from 'src/components/Page';
import Toolbar from './Toolbar';
import StateCard from './StateCard';
import StateService from '../../../services/StateService';

const useStyles = makeStyles((theme) => ({
  root: {
    backgroundColor: theme.palette.background.dark,
    minHeight: '100%',
    paddingBottom: theme.spacing(3),
    paddingTop: theme.spacing(3)
  },
  stateCard: {
    height: '100%'
  }
}));

const StateList = () => {
  const classes = useStyles();
  const { id } = useParams();
  const [states, setStates] = useState([]);

  useEffect(() => {
    const foo = async () => {
      const fetchData = typeof id !== 'undefined'
        ? await StateService.getById(id)
        : await StateService.getAll();

      if (fetchData?.code === 200) {
        if (id) {
          setStates([fetchData.data]);
        } else {
          setStates(fetchData.data);
        }
      }
    };

    foo();
  }, [id]);

  return (
    <Page
      className={classes.root}
      title="Estados"
    >
      <Container maxWidth={false}>
        <Toolbar />
        <Box mt={3}>
          <Grid
            container
            spacing={3}
          >
            {states.map((state) => (
              <Grid
                item
                key={state.id}
                lg={4}
                md={6}
                xs={12}
              >
                <StateCard
                  className={classes.stateCard}
                  state={state}
                />
              </Grid>
            ))}
          </Grid>
        </Box>
        <Box
          mt={3}
          display="flex"
          justifyContent="center"
        >
          <Pagination
            color="primary"
            count={3}
            size="small"
          />
        </Box>
      </Container>
    </Page>
  );
};

export default StateList;
